<div class="cg-dialog">
  <button
    cignaButton="link inline no-underline"
    class="cg-dialog__close"
    (click)="close()"
  >
    Close
    <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
  </button>

  <h2 class="cg-dialog__header">What Is a Temporary ID?</h2>

  <mat-dialog-content>
    <p class="margin-top0">
      You may have received a letter from Cigna with a temporary ID, password
      and registration instructions.
    </p>
    <p>
      Or someone in your office may have assigned website access to you and
      given you a temporary ID and password.
    </p>
    <h4>How can I save time and get a temporary ID and password?</h4>
    <p>
      People in your office who are already registered with this Cigna website
      may be able to give you immediate, full and secure website access. Contact
      one of them and ask.
    </p>
    <p>
      To assign access, the person already registered logs in and chooses Assign
      Access on the Working with Cigna screen. Once that person completes the
      assign access process, they'll receive a temporary ID and password to give
      to you.
    </p>
  </mat-dialog-content>
</div>
